function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.6893 22.9678V58.0492H29.5269V37.2927L18.3447 45.4053L7.16246 37.2927V58.0492H0V22.9678L18.3447 36.9273L36.6893 22.9678Z",
  className: "magicw"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M66.1431 53.4448H49.4063L47.2137 58.0492H39.7589L57.9574 22.9678L76.229 58.0492H68.4087L66.1431 53.4448ZM52.4759 46.9401H62.9273L57.6651 36.1964L52.4759 46.9401Z",
  className: "magicw"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M110.58 40.2892C110.58 50.4482 102.613 58.6339 92.7465 58.6339C82.8799 58.6339 74.9866 50.6675 74.9866 40.8008C74.9866 30.9342 82.8799 22.9678 92.6735 22.9678C99.105 22.9678 104.806 26.3297 107.875 31.3727L102.102 35.5386C100.274 32.1766 96.7663 29.8379 92.6735 29.8379C86.8996 29.8379 82.2952 34.7347 82.2952 40.8739C82.2952 46.9401 86.8996 51.7638 92.6735 51.7638C96.8394 51.7638 100.713 49.6443 102.175 45.6245H92.8196V39.266H110.507V40.2892H110.58Z",
  className: "magicw"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M169.195 42.8469C168.172 51.6903 160.571 58.7066 151.435 58.7066C141.568 58.7066 133.675 50.7402 133.675 40.8736C133.675 31.0069 141.568 23.0405 151.362 23.0405C157.793 23.0405 163.494 26.4025 166.564 31.4454L160.936 35.3921C158.451 31.6647 154.943 29.9106 151.362 29.9106C145.588 29.9106 140.983 34.8074 140.983 40.9467C140.983 47.0128 145.588 51.8365 151.362 51.8365C156.551 51.8365 160.863 48.1091 161.886 42.92H169.195V42.8469Z",
  className: "magicw"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M233.438 23.5522H240.892L223.352 58.6337L215.824 44.4549L208.734 58.6337L190.317 23.5522H198.575L209.027 43.7971L212.243 37.5117L204.934 23.5522H213.193L223.644 43.7971L233.438 23.5522Z",
  className: "magicw"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M258.506 53.4448H241.769L239.577 58.0492H232.195L250.394 22.9678L268.665 58.0492H260.845L258.506 53.4448ZM244.912 46.9401H255.363L250.101 36.1964L244.912 46.9401Z",
  className: "magicw"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M296.146 23.5523H303.308V58.6337L278.751 38.2427V58.049H271.589V22.8945L296.146 43.5049V23.5523Z",
  className: "magicw"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M323.918 23.5522C333.858 23.5522 341.971 30.934 341.971 40.8006C341.971 50.7403 333.858 58.049 323.992 58.049H309.886V23.5522H323.918ZM323.918 51.5443C329.912 51.5443 334.589 46.9399 334.589 40.7275C334.589 34.4421 329.912 29.9838 323.918 29.9838H317.121V51.5443H323.918Z",
  className: "magicw"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M117.669 20.0444L112.845 21.7985L125.855 58.7802L130.898 56.953L117.669 20.0444Z",
  className: "magicw-i"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M111.969 5.13467C113.503 4.18454 114.673 2.94208 115.623 1.48035C116.061 0.749488 115.842 0.384056 114.892 0.237884L115.477 0.0186249C115.988 -0.0544614 116.354 0.0917112 116.646 0.384056C117.158 0.749488 116.938 1.48035 116.208 2.72282C115.477 3.8922 114.38 5.06158 112.992 6.08479C112.699 6.30405 112.48 6.45022 112.188 6.66948",
  className: "magicw-i"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M112.261 4.98878C112.114 4.98878 110.214 6.01199 110.141 6.08507C108.533 6.66976 107.218 7.10828 106.194 7.10828C105.244 7.10828 105.391 6.37742 106.56 4.84261C106.925 4.331 107.364 3.96557 107.875 3.67322C108.387 3.38088 108.606 3.23471 108.606 3.23471L108.095 3.16162C107.949 3.16162 107.51 3.38088 106.852 3.8194C105.756 4.40409 104.952 5.20804 104.66 6.23125C104.294 7.18137 104.514 7.83914 105.244 8.27766C106.194 8.71618 107.51 8.71618 109.264 8.13149C111.018 7.47371 111.018 7.47371 112.48 6.52359",
  className: "magicw-i"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M115.258 14.4897C117.962 12.7356 120.154 10.4699 121.908 7.8388C122.785 6.52325 122.347 5.86547 120.666 5.64621L121.762 5.28078C122.639 5.13461 123.37 5.35387 123.882 5.86547C124.686 6.52325 124.32 7.91189 123.005 10.1045C121.616 12.2971 119.643 14.3435 117.231 16.1706C116.719 16.5361 116.281 16.9015 115.769 17.2669",
  className: "magicw-i"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M115.915 14.1972C115.623 14.2703 112.261 16.0975 112.042 16.1706C109.118 17.2669 106.78 18.0708 104.952 18.0708C103.271 18.0708 103.564 16.6822 105.61 13.978C106.268 13.1009 107.072 12.3701 107.949 11.8585C108.826 11.3469 109.264 11.1276 109.264 11.1276L108.387 10.9814C108.095 10.9814 107.364 11.3469 106.122 12.1508C104.148 13.2471 102.76 14.7088 102.175 16.4629C101.59 18.217 101.956 19.4595 103.198 20.1172C104.879 20.9943 107.291 20.8481 110.434 19.8249C113.65 18.6555 113.65 18.6555 116.281 16.9014",
  className: "magicw-i"
});

var SvgMagicWand = function SvgMagicWand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 342 59",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMagicWand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/magic-wand.b6a2164f.svg";
export { ForwardRef as ReactComponent };